import selectInsurance from 'utils/selectInsurance';

const getInsuranceType = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  return selectedInsurance && selectedInsurance['Claim Filling Code'] && selectedInsurance['Claim Filling Code'].ID
    ? selectedInsurance['Claim Filling Code'].ID.toString() : null;
};

export default getInsuranceType;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceType.js